import React from 'react'
import ContactHero from '../components/contact/ContactHero'
import ContactFormSection from '../components/contact/ContactFormSection'
import ContactBenefitsSection from '../components/contact/ContactBenefitsSection'
import SEO from '../components/seo/SEO'

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us | Logo Branded Door Mats Johannesburg – Get a Free Quote"
        description="Contact Logo Branded Door Mats Johannesburg for custom logo mat quotes. Call/WhatsApp: +27 (81) 063-4772. Email: care@logobrandeddoormats.co.za. Based in Isando, Kempton Park. 2–3 day Gauteng delivery."
        keywords="contact logo branded door mats Johannesburg, door mat quote South Africa, custom mat enquiry Gauteng, branded mat supplier SA, mat specialist Kempton Park"
        url="https://www.logobrandeddoormats.co.za/contact"
        image="https://www.logobrandeddoormats.co.za/images/sectionimages/contact page.png"
      />
      <ContactHero />
      <ContactFormSection />
      <ContactBenefitsSection />
    </>
  )
}
